import { Location, useAppLocationVar } from '../models/AppLocation'

export const updateAppLocationFn = (updatedAppLocation: Location): Location => {
  return useAppLocationVar(updatedAppLocation)
}
